
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.21 48.48c.45.44 1.04.66 1.62.66.59 0 1.17-.22 1.63-.66L46.35 34.1l.167-.157c.152-.143.298-.28.423-.413l.1-.09c.08-.09.15-.17.21-.25 2.21-2.45 3.43-5.6 3.43-8.89 0-7.33-5.97-13.3-13.3-13.3-2.72 0-5.31.81-7.54 2.35A13.169 13.169 0 0022.3 11C14.97 11 9 16.97 9 24.3c0 3.2 1.16 6.29 3.27 8.72.06.09.14.18.23.27l.11.1c.3.32.61.62.9.87l14.7 14.22zm-14.17-16.5l-.12-.11a1.135 1.135 0 00-.03-.038.657.657 0 01-.06-.082A11.306 11.306 0 0111 24.29c0-6.23 5.07-11.3 11.3-11.3 2.52 0 4.91.82 6.92 2.38.36.28.87.28 1.23 0 2-1.56 4.4-2.38 6.92-2.38 6.23 0 11.3 5.07 11.3 11.3 0 2.82-1.05 5.52-2.96 7.61-.03.03-.06.07-.09.11l-.1.1c-.17.17-.34.34-.54.52L30.07 47.04c-.13.12-.33.13-.46 0L14.87 32.78c-.28-.24-.54-.5-.83-.8zm30.88-7.6c0 .55.45 1 1 1s1-.45 1-1c0-5.29-4.3-9.6-9.6-9.6-.55 0-1 .45-1 1s.45 1 1 1c4.19 0 7.6 3.41 7.6 7.6z"}})])
          )
        }
      }
    